// extracted by mini-css-extract-plugin
module.exports = {"container":"Groups_container__3IG4u","searchContainer":"Groups_searchContainer__XzV01"};